var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail"},[_c('Header'),_c('main',{staticClass:"layout content-inner"},[_c('div',{attrs:{"id":"page"},domProps:{"innerHTML":_vm._s(_vm.content)}}),_c('AsideContent')],1),_c('Footer'),_c('ToTop')],1)}
var staticRenderFns = []

export { render, staticRenderFns }